const tokens = {
    cursor: {
        none: 'none',
        pointer: 'pointer',
        move: 'move',
    },
    spacings: {
        '0': '0px',
        '4': '4px',
        '8': '8px',
        '12': '12px',
        '16': '16px',
        '20': '20px',
        '32': '32px',
        '24': '24px',
        '40': '40px',
        '48': '48px',
        '64': '64px',
    },
    sizes: {
        '0': '0px',
        '1': '1px',
        '4': '4px',
        '8': '8px',
        '12': '12px',
        '16': '16px',
        '20': '20px',
        '24': '24px',
        '28': '28px',
        '32': '32px',
        '40': '40px',
        '44': '44px',
        '48': '48px',
        '64': '64px',
        '80': '80px',
        '96': '96px',
        '128': '128px',
        '160': '160px',
        '192': '192px',
        '224': '224px',
        '256': '256px',
        full: '100%',
        'max-content': 'max-content',
    },
    fontSizes: {
        '12': '12px',
        '14': '14px',
        '16': '16px',
        '20': '20px',
        '24': '24px',
        '32': '32px',
        '48': '48px',
        '64': '64px',
        '96': '96px',
    },
    fontWeights: {
        light: 200,
        normal: 400,
        semibold: 500,
        bold: 700,
        inherit: 'inherit',
    },
    lineHeights: {
        none: 1,
        condensed: 1.25,
        normal: 1.5,
        relaxed: 1.75,
    },
    letterSpacings: {
        tighter: '-0.05em',
        tight: '-0.025em',
        normal: '0',
        wide: '0.025em',
        wider: '0.05em',
        widest: '0.1em',
    },
    colors: {
        transparent: 'transparent',
        white: '#fff',
        black: '#000',
        gainsboro: 'gainsboro',
        'grey.3': '#6E7882',
        'grey.4': '#F0F4F8',
        'grey.5': '#434A58',
        'grey.6': '#363C44',
        'orange.1': '#FFF2EB',
        'orange.3': '#FF8A51',
        'orange.4': '#FF5501',
        'orange.5': '#BD3402',
        'blue.3': '#24237C',
        'blue.4': '#010033',
        'blue.5': '#2F3146',
    },
    shadows: {
        small: '0 0 1px hsla(208.6, 24.7%, 34.9%, 0.3), 0 2px 4px -2px hsla(208, 24.7%, 34.9%, 0.45)',
        medium: '0 0 1px hsla(208.6, 24.7%, 34.9%, 0.3), 0 5px 8px -4px hsla(208, 24.7%, 34.9%, 0.45)',
        large: '0 0 1px hsla(208.6, 24.7%, 34.9%, 0.3), 0 8px 10px -4px hsla(208, 24.7%, 34.9%, 0.45)',
        xlarge: '0 0 1px hsla(208.6, 24.7%, 34.9%, 0.3), 0 16px 24px -8px hsla(208, 24.7%, 34.9%, 0.45)',
        focusRing: '0 0 0 3px hsla(211, 97%, 61%, 0.45), 0 0 0 1px hsl(211, 97%, 61%)',
    },
    borders: {
        '0': '0',
        '1': '1px solid',
        '2': '2px solid',
        '3': '3px solid',
    },
    radii: {
        '0': '0',
        '4': '4px',
        '8': '8px',
        '12': '12px',
        '24': '24px',
        inherit: 'inherit',
    },
    timingDurations: {
        fast: '150ms',
        normal: '300ms',
        slow: '450ms',
        slowest: '600ms',
    },
    timingFunctions: {
        standard: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
        slow: 'cubic-bezier(0.0, 0.0, 0.2, 1)',
        fast: 'cubic-bezier(0.4, 0.0, 1, 1)',
        sharp: 'cubic-bezier(0.4, 0.0, 0.6, 1)',
        spring: 'cubic-bezier(0.175, 0.885, 0.320, 1.175)',
    },
};

export default tokens;
export type Tokens = typeof tokens;
